export function scheduleIdle(cb: () => void) {
  if ('requestIdleCallback' in window) {
    return requestIdleCallback(cb, { timeout: 2000 });
  }
  return setTimeout(cb, 300) as unknown as number;
}

export function cancelScheduleIdle(id: number) {
  if ('cancelIdleCallback' in window) {
    return cancelIdleCallback(id);
  }
  return clearTimeout(id);
}
